import type { ReactNode } from "react";
import { Link } from "react-router";
import styles from "./Card.module.css";

interface Props {
  children: ReactNode;
  /** Makes the whole card a link. Omit for a static panel. */
  to?: string;
  /** Renders as non-interactive: no hover, no navigation. */
  disabled?: boolean;
  className?: string;
}

/** §07 bordered card: --line → --cyan on hover, no lift, no shadow, square. */
export function Card({ children, to, disabled = false, className }: Props) {
  const interactive = Boolean(to) && !disabled;
  const classes = [
    styles.card,
    interactive && styles.interactive,
    disabled && styles.disabled,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (interactive && to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }

  return <div className={classes}>{children}</div>;
}
